export default __webpack_public_path__ + "static/media/next.708f2da7.svg";